import { SVGProps } from 'react';

const Nonprofit = ({
  props,
  fill = 'currentColor',
  size = 24,
}: {
  props?: SVGProps<SVGSVGElement>;
  fill?: string;
  size?: string | number;
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill={fill}
      d="M19.24 16.777A2.25 2.25 0 1 0 17 19.25l.223-.01A2.25 2.25 0 0 0 19.25 17l-.01-.223Zm0-10a2.25 2.25 0 1 0 .01.223l-.01-.223ZM4.76 12.221A2.25 2.25 0 0 0 9.25 12l-.01-.22a2.25 2.25 0 0 0-2.02-2.02L7 9.75A2.251 2.251 0 0 0 4.75 12l.01.22Zm15.985-5.035a3.75 3.75 0 0 1-5.454 3.15L13.961 12l1.33 1.662A3.75 3.75 0 0 1 20.75 17l-.005.186a3.75 3.75 0 0 1-3.56 3.56L17 20.75a3.75 3.75 0 0 1-2.88-6.15l-1.481-1.85h-1.965a3.741 3.741 0 0 1-3.674 3 3.751 3.751 0 0 1-3.745-3.565L3.25 12A3.751 3.751 0 0 1 7 8.25l.185.005a3.752 3.752 0 0 1 3.28 2.31c.092.221.161.451.209.685h1.965l1.48-1.85A3.75 3.75 0 1 1 20.75 7l-.005.186Z"
    />
  </svg>
);

export default Nonprofit;
